const actionTypes = {
    ADD_FLASH_ON_PDP: 'ADD_FLASH_ON_PDP',
    BEAUTY_MATCH_FILTERS_TOGGLED: 'BEAUTY_MATCH_FILTERS_TOGGLED',
    CHANGE_CURRENT_SKU: 'CHANGE_CURRENT_SKU',
    CUSTOM_SETS_CHOICE_UPDATED: 'CUSTOM_SETS_CHOICE_UPDATED',
    GALLERY_FILTERS_APPLIED: 'GALLERY_FILTERS_APPLIED',
    HOVERED_SKU: 'HOVERED_SKU',
    PURCHASES_FILTER_OPTIONS: 'PURCHASES_FILTER_OPTIONS',
    RESET_GALLERY_FILTERS: 'RESET_GALLERY_FILTERS',
    RESTORE_PRODUCT_WITH_NO_EXTRA_DETAILS: 'RESTORE_PRODUCT_WITH_NO_EXTRA_DETAILS',
    REVIEW_FILTERS_APPLIED: 'REVIEW_FILTERS_APPLIED',
    REVIEW_FILTERS_SELECTED: 'REVIEW_FILTERS_SELECTED',
    REVIEW_SEARCH_APPLIED: 'REVIEW_SEARCH_APPLIED',
    SELECT_FILTER_OPTION: 'SELECT_FILTER_OPTION',
    SELECT_SORT_OPTION: 'SELECT_SORT_OPTION',
    SET_PRODUCT: 'SET_PRODUCT',
    SUBSCRIPTION: {
        ACTION_TYPE: 'cancel',
        TYPE: 'outOfStock'
    },
    TOGGLE_CUSTOM_SETS: 'TOGGLE_CUSTOM_SETS',
    TOGGLE_SWATCHES: 'TOGGLE_SWATCHES',
    UPDATE_CURRENT_PRODUCT_USER_SPECIFIC: 'UPDATE_CURRENT_PRODUCT_USER_SPECIFIC',
    UPDATE_CURRENT_PRODUCT: 'UPDATE_CURRENT_PRODUCT',
    UPDATE_CURRENT_SKU_IN_CURRENT_PRODUCT: 'UPDATE_CURRENT_SKU_IN_CURRENT_PRODUCT',
    UPDATE_QUANTITY_OF_CURRENT_SKU: 'UPDATE_QUANTITY_OF_CURRENT_SKU',
    UPDATE_RELATED_LINKS: 'UPDATE_RELATED_LINKS',
    UPDATE_RESERVE_ONLINE_PICK_UP_IN_STORE_DETAILS: 'UPDATE_RESERVE_ONLINE_PICK_UP_IN_STORE_DETAILS',
    UPDATE_SAME_DAY_DELIVERY_DETAILS: 'UPDATE_SAME_DAY_DELIVERY_DETAILS',
    VERIFIED_PURCHASER_FILTERS_TOGGLED: 'VERIFIED_PURCHASER_FILTERS_TOGGLED'
};

module.exports = actionTypes;
